import { Post } from "../utils/http.js"

export function getIsOnline(params) {
  return Post("/api/mem/auth/isOnline", params)
}

export function getAccountInfo(params, config = {}) {
  return Post("/api/member/infoPoint", params, config)
}

export function logOut(params) {
  return Post("/api/mem/auth/logout", params)
}
